import gql from 'graphql-tag';

export const municipalityFragments = gql`
  fragment municipalityFragments on Municipality {
    id
    number
    name
    bban
    organizationNumber
    organizationName
    organizationForm
    comment
    webpage
    email
    telephone
    mobile
    telefax
    address1
    address2
    address3
    zip
    city
    countyName
    employerTaxZone {
      id
      rate
      code
    }
  }
`;

export const ALL_MUNICIPALITIES = gql`
  query municipalities {
    currentUnit {
      id
      municipalities {
        ...municipalityFragments
      }
    }
  },
  ${municipalityFragments}
`;
